@if (viewVisible) {
  <mat-toolbar color="secondary">
    <ldw-document-title [document]="document"></ldw-document-title>
    <div class="changedtext">{{(history?.changed) ?? ""}} {{(history?.changedBy) ?? ""}}</div>
    <span class="spacer"></span>
    <ldw-document-images [document]="document"></ldw-document-images>
    <div class="buttons">
      <button mat-icon-button (click)="close()" matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  @if (isPdfViewer()) {
    <ldw-pdf-history-viewer [document]="document" [history]="history"
      [downloadAllowed]="downloadAllowed()"
    [printAllowed]="printingAllowed()"></ldw-pdf-history-viewer>
  }
  @if (isPdfEditor()) {
    <ldw-pdft-history-viewer [document]="document" [history]="history"
      [downloadAllowed]="downloadAllowed()"
    [printAllowed]="printingAllowed()"></ldw-pdft-history-viewer>
  }
}
